export const commonItIt = {
  brand: {
    logoAlt: 'Logo Safi',
    name: 'Safi',
    vatLabel: 'Safi IVA',
  },
  currencySelectField: {
    groups: {
      other: 'Altro',
      suggested: 'Suggerito',
    },
  },
  domains: {
    evidence: 'Prove',
    evidenceLower: 'prove',
    qualityControl: 'Controllo qualità',
    qualityControlLower: 'controllo qualità',
  },
  values: {
    emptyValue: '-',
  },
} as const;
